<template>
	<modal
		ref="dashboardOnboardingModal"
		title="Welcome to MyAbdom">
		<template #body>
			<template v-if="step == 1">
				<div>
					<p>
						Remitting the Agency Placement Fee is an important part of our business relationship. As a
						registered service provider with Absolute Domestics, you are responsible for passing on our
						Agency
						Placement Fees at the end of each week.<br><br>

						Please follow the steps below so that we can reconcile Agency Placement Fees and the Insurance
						Levy
						for the payment week Saturday to Friday:
					</p>
					<h2>Service completed</h2>
					<ol>
						<li>
							Log into
							<a href="https://my.absolutedomestics.com.au">https://my.absolutedomestics.com.au/</a>
						</li>
						<li>
							Select Fees from the Fees tab to view payments due for Absolute Domestics clients scheduled
							that week
						</li>
						<li>
							Select all jobs completed. This automatically calculates the fee and Insurance Levy due for
							the
							job
						</li>
						<li>
							If the job did not go ahead or was changed for any reason, please refer below for further
							instructions
						</li>
						<li>
							Select Make Payment to pay by visa, debit or credit card. If using a card different to the
							one
							used for your Registration Fee, select Change and enter the correct details. Payments are
							processed through Stripe who have in place the highest grade of payment processing security
							available for added peace of mind.
						</li>
						<li> A fee summary will then be emailed to you confirming your payment</li>
					</ol>
				</div>
			</template>
			<template v-if="step == 2">
				<div>
					<h2>Service missed</h2>
					<p>
						If a job did not go ahead for any reason, please click Job Not Done and select a reason from the
						drop down menu to let us know why.

						An automated text message is sent to the client to confirm the service was missed. This helps us
						keep in touch with the client so that we can continue to offer a high standard of customer
						service.
					</p>
					<h2>Service changed</h2>
					<p>
						Please contact your Team Manager if there is a permanent change to a clients booking. Your Team Manager will then update your roster and the booking to reflect these changes.

						If the day of the service changes but you still clean for the client during the same week, treat the job as completed. There is no need to advise us of a one off change within the same week.
					</p>
					<h2>Service not showing</h2>
					<p>
						If an Absolute Domestics job you have completed is not showing on the portal for any reason,
						please contact your Team Manager to resolve. This includes extra jobs a current client requests
						that does not form part of their regular service.

						Your Team Manager will generate the fee so that you can select the job as completed and very
						shortly you will have the ability to add this in yourself.
					</p>
				</div>
			</template>
			<template v-if="step == 3">
				<div>
					<h2>Need help</h2>
					<p>
						Please contact your Team Manager if you have any questions or issues paying online.
					</p>
				</div>
			</template>
		</template>
		<template #footer>
			<button
				class="btn btn-primary"
				@click="next">
				Next
			</button>
		</template>
	</modal>
</template>

<script>
	import Modal from '@js/components/Modal.vue';

	export default {
		components: {
			Modal
		},
		data() {
			return {
				step: 1
			}
		},
		mounted() {
			this.$refs.dashboardOnboardingModal.open();
		},
		methods: {
			next() {
				if (this.step == 3) {
					this.$refs.dashboardOnboardingModal.close();
					this.$axios.post('/api/account/update-onboarding', {
						type: 'dashboard'
					}).then(() => {
						this.$router.push('/fees');
					});
				}

				this.step++;
			}
		}
	}
</script>


<style scoped>
	.onboarding-gif {
		width: 100%;
	}

	@media (min-width: 768px) {
		.onboarding-gif {
			width: 50%;
		}
	}
</style>
